import React from 'react';

export default function EducationHeader() {
  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-900">Education</h2>
      <p className="mt-1 text-gray-600">
        Add your educational background, starting with your highest degree. Include relevant coursework,
        honors, and academic achievements.
      </p>
    </div>
  );
}